import React from "react";

import ChatContainer from "../../../components/chat";


const OrderChat = ({record, ...props}) => (
	<ChatContainer
		record={record}
		resourcePath={`orders/${record.id}/messages`}
		{...props}
	/>
);

export default OrderChat;
